import { useCallback } from 'react';
import { useRevalidator } from 'react-router-dom';
import { DisplayCampaignInformation } from '../../types/campaigns.type';
import Button from '../buttons/baseButton';
import { useModal } from '../modalProvider';
import ReviewSendCampaign from './reviewSendCampaign';
import { CampaignStatus, Channel } from '../../types/enums';
import ApproveSendCampaign from './approveSendCampaign';

export default function RenderReleaseCampaignButton(data: DisplayCampaignInformation, buttonText: string) {
  const { openSimpleModal, closeModal } = useModal();
  const revalidator = useRevalidator();

  const showReviewSendModal = useCallback(() => {
    const handleClose = () => {
      closeModal();
      revalidator.revalidate();
    };

    openSimpleModal({
      isOpen: true,
      title: 'Review & Send Campaign',
      children: <ReviewSendCampaign rowData={data} onClose={handleClose} />,
      onClose: handleClose,
    });
  }, [openSimpleModal, closeModal, revalidator, data]);

  const showApproveCampaignModal = useCallback(() => {
    const handleClose = () => {
      closeModal();
      revalidator.revalidate();
    };

    openSimpleModal({
      isOpen: true,
      title: 'Approve & Send Campaign',
      children: <ApproveSendCampaign rowData={data} onClose={handleClose} />,
      onClose: handleClose,
      size: 'large',
    });
  }, [openSimpleModal, closeModal, revalidator, data]);

  const { campaignCommunicationId: id, communicationChannel, status } = data;

  if (communicationChannel === Channel.BackendLetter && status === CampaignStatus.AwaitingApproval) {
    return (
      <Button
        id={`approve-letter-campaign-button-${id}`}
        className="!text-xs button-default !pointer-events-auto"
        label="Review & Send"
        onClick={showApproveCampaignModal}
      />
    );
  }

  if (communicationChannel === Channel.BackendSMS && status === CampaignStatus.ReadyForReview) {
    if (revalidator.state === 'loading') {
      return (
        <Button
          id={`${id}-loading`}
          className="!text-xs button-default !pointer-events-auto"
          label="..."
          onClick={() => {}}
          isDisabled
        />
      );
    }
    return (
      <Button
        id={`${buttonText}-campaign-button-${id}`}
        className="!text-xs button-default !pointer-events-auto"
        label={buttonText}
        onClick={showReviewSendModal}
      />
    );
  }
  return null;
}
